export const APP_NAV_DEFAULT_HEIGHT = 8 * 8; // 64px – 8 lines on the Genesis 8px grid
